module.exports = __webpack_public_path__ + "static/img/Edima.1f5d0a9.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Edima.jpeg
// module id = GpWl
// module chunks = 0